export const churchRecord = {
	GET_RECORD: "churchRecord/get",
	GET_RECORD_DETAIL: "churchRecord/detail",
}

export default churchRecord
